// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contratos_MinutasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /contratos/minutas/:franquia_id — as minutas da franquia (Full). */
import type { Contratos_MinutaRow } from './Contratos_MinutaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contratos_MinutasResponseDados {
modelo_versao_vigente: number
minutas: Contratos_MinutaRow[]
}

export type Contratos_MinutasResponse = ApiResponse<Contratos_MinutasResponseDados>;

registerResponseContract('Contratos_MinutasResponse', {
  modelo_versao_vigente: { type: 'number',  required: true },
  minutas: {
    type: 'array',
    required: true,
    items: {
      id:            { type: 'number',  required: true },
      franquia_id:   { type: 'number',  required: true },
      modelo_versao: { type: 'number',  required: true },
      situacao:      { type: 'string',  required: true },
      pedido:        { type: 'string',  required: false },
      clausulas: {
        type: 'array',
        required: false,
        items: {
          chave:  { type: 'string',  required: false },
          titulo: { type: 'string',  required: false },
          texto:  { type: 'string',  required: false },
          fixa:   { type: 'boolean', required: false },
        },
      },
      padrao: {
        type: 'array',
        required: false,
        items: {
          chave:  { type: 'string',  required: false },
          titulo: { type: 'string',  required: false },
          texto:  { type: 'string',  required: false },
          fixa:   { type: 'boolean', required: false },
        },
      },
      criado_por:    { type: 'string',  required: false },
      atualizado_em: { type: 'string',  required: true },
      aprovado_por:  { type: 'string',  required: false },
      aprovado_em:   { type: 'string',  required: false },
    },
  },
})
